/* src/app/add-note/add-thoughts/add-thoughts.scss */
:root {
  --ion-background-color:
    linear-gradient(
      299deg,
      #371A09 2.43%,
      #885F26 100%);
  --ion-dark-background: #624120;
  --ion-color-primary-lightbrown: #785838;
  --ion-color-primary-lightgreen: #24615B;
  --ion-color-primary: #3880ff;
  --ion-color-primary-rgb:
    56,
    128,
    255;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-primary-shade: #3171e0;
  --ion-color-primary-tint: #4c8dff;
  --ion-color-primary-brown: #62412080;
  --ion-color-primary-brown-light: #9a6d3a;
  --ion-color-primary-darkgreen: #004147;
  --ion-color-primary-lightblue: #3FDECE;
  --ion-color-secondary: #3dc2ff;
  --ion-color-secondary-rgb:
    61,
    194,
    255;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-secondary-shade: #36abe0;
  --ion-color-secondary-tint: #50c8ff;
  --ion-color-tertiary: #5260ff;
  --ion-color-tertiary-rgb:
    82,
    96,
    255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb:
    255,
    255,
    255;
  --ion-color-tertiary-shade: #4854e0;
  --ion-color-tertiary-tint: #6370ff;
  --ion-color-success: #2dd36f;
  --ion-color-success-rgb:
    45,
    211,
    111;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb:
    255,
    255,
    255;
  --ion-color-success-shade: #28ba62;
  --ion-color-success-tint: #42d77d;
  --ion-color-warning: #ffc409;
  --ion-color-warning-rgb:
    255,
    196,
    9;
  --ion-color-warning-contrast: #000000;
  --ion-color-warning-contrast-rgb:
    0,
    0,
    0;
  --ion-color-warning-shade: #e0ac08;
  --ion-color-warning-tint: #ffca22;
  --ion-color-danger: #eb445a;
  --ion-color-danger-rgb:
    235,
    68,
    90;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb:
    255,
    255,
    255;
  --ion-color-danger-shade: #cf3c4f;
  --ion-color-danger-tint: #ed576b;
  --ion-color-dark: #222428;
  --ion-color-dark-rgb:
    34,
    36,
    40;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb:
    255,
    255,
    255;
  --ion-color-dark-shade: #1e2023;
  --ion-color-dark-tint: #383a3e;
  --ion-color-medium: #92949c;
  --ion-color-medium-rgb:
    146,
    148,
    156;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb:
    255,
    255,
    255;
  --ion-color-medium-shade: #808289;
  --ion-color-medium-tint: #9d9fa6;
  --ion-color-light: #f4f5f8;
  --ion-color-light-rgb:
    244,
    245,
    248;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb:
    0,
    0,
    0;
  --ion-color-light-shade: #d7d8da;
  --ion-color-light-tint: #f5f6f9;
  --gentle-rock-scale: 1.2;
}
@media (prefers-color-scheme: dark) {
  body {
    --ion-color-primary: #428cff;
    --ion-color-primary-rgb:
      66,
      140,
      255;
    --ion-color-primary-contrast: #ffffff;
    --ion-color-primary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-primary-shade: #3a7be0;
    --ion-color-primary-tint: #5598ff;
    --ion-color-secondary: #50c8ff;
    --ion-color-secondary-rgb:
      80,
      200,
      255;
    --ion-color-secondary-contrast: #ffffff;
    --ion-color-secondary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-secondary-shade: #46b0e0;
    --ion-color-secondary-tint: #62ceff;
    --ion-color-tertiary: #6a64ff;
    --ion-color-tertiary-rgb:
      106,
      100,
      255;
    --ion-color-tertiary-contrast: #ffffff;
    --ion-color-tertiary-contrast-rgb:
      255,
      255,
      255;
    --ion-color-tertiary-shade: #5d58e0;
    --ion-color-tertiary-tint: #7974ff;
    --ion-color-success: #3FDECE;
    --ion-color-success-rgb:
      63,
      222,
      206;
    --ion-color-success-contrast: #000000;
    --ion-color-success-contrast-rgb:
      0,
      0,
      0;
    --ion-color-success-shade: #29c467;
    --ion-color-success-tint: #44e283;
    --ion-color-warning: #ffd534;
    --ion-color-warning-rgb:
      255,
      213,
      52;
    --ion-color-warning-contrast: #000000;
    --ion-color-warning-contrast-rgb:
      0,
      0,
      0;
    --ion-color-warning-shade: #e0bb2e;
    --ion-color-warning-tint: #ffd948;
    --ion-color-danger: #ff4961;
    --ion-color-danger-rgb:
      255,
      73,
      97;
    --ion-color-danger-contrast: #ffffff;
    --ion-color-danger-contrast-rgb:
      255,
      255,
      255;
    --ion-color-danger-shade: #e04055;
    --ion-color-danger-tint: #ff5b71;
    --ion-color-dark: #f4f5f8;
    --ion-color-dark-rgb:
      244,
      245,
      248;
    --ion-color-dark-contrast: #000000;
    --ion-color-dark-contrast-rgb:
      0,
      0,
      0;
    --ion-color-dark-shade: #d7d8da;
    --ion-color-dark-tint: #f5f6f9;
    --ion-color-medium: #989aa2;
    --ion-color-medium-rgb:
      152,
      154,
      162;
    --ion-color-medium-contrast: #000000;
    --ion-color-medium-contrast-rgb:
      0,
      0,
      0;
    --ion-color-medium-shade: #86888f;
    --ion-color-medium-tint: #a2a4ab;
    --ion-color-light: #222428;
    --ion-color-light-rgb:
      34,
      36,
      40;
    --ion-color-light-contrast: #ffffff;
    --ion-color-light-contrast-rgb:
      255,
      255,
      255;
    --ion-color-light-shade: #1e2023;
    --ion-color-light-tint: #383a3e;
  }
  .ios body {
    --ion-text-color: #ffffff;
    --ion-text-color-rgb:
      255,
      255,
      255;
    --ion-color-step-50: #0d0d0d;
    --ion-color-step-100: #1a1a1a;
    --ion-color-step-150: #262626;
    --ion-color-step-200: #333333;
    --ion-color-step-250: #404040;
    --ion-color-step-300: #4d4d4d;
    --ion-color-step-350: #595959;
    --ion-color-step-400: #666666;
    --ion-color-step-450: #737373;
    --ion-color-step-500: #808080;
    --ion-color-step-550: #8c8c8c;
    --ion-color-step-600: #999999;
    --ion-color-step-650: #a6a6a6;
    --ion-color-step-700: #b3b3b3;
    --ion-color-step-750: #bfbfbf;
    --ion-color-step-800: #cccccc;
    --ion-color-step-850: #d9d9d9;
    --ion-color-step-900: #e6e6e6;
    --ion-color-step-950: #f2f2f2;
    --ion-item-background: #000000;
    --ion-card-background: #1c1c1d;
  }
  .ios ion-modal {
    --ion-background-color: var(--ion-color-step-100);
    --ion-toolbar-background: var(--ion-color-step-150);
    --ion-toolbar-border-color: var(--ion-color-step-250);
  }
}
@media screen and (min-width: 768px) and (orientation: portrait) {
  ::ng-deep .buttons .button {
    font-size: 18px !important;
    height: 70px !important;
  }
}
@media screen and (max-width: 420px) and (max-height: 750px) and (orientation: portrait) {
  ::ng-deep .buttons .button {
    height: 50px !important;
    font-size: 13px !important;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  ::ng-deep .buttons .button {
    height: 50px !important;
    font-size: 13px !important;
  }
}
@media screen and (max-height: 425px) and (max-width: 740px) and (orientation: landscape) {
  ::ng-deep .buttons .button {
    height: 40px !important;
  }
}
.wrapper {
  min-height: 100svh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background:
    linear-gradient(
      299deg,
      #371A09 2.43%,
      #885F26 100%);
}
.wrapper .content {
  height: 100svh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
}
.wrapper .header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 27px 24px 0 0;
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .header {
    padding: 15px 15px 0 0;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .header {
    padding: 10px 10px 0 0;
  }
}
.wrapper .header .logo {
  width: 50px;
  height: 50px;
}
@media screen and (min-width: 768px) {
  .wrapper .header .logo {
    width: 80px;
    height: 80px;
  }
}
@media screen and (orientation: landscape) {
  .wrapper .header .logo {
    width: 50px;
    height: 50px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .header .logo {
    width: 40px;
    height: 40px;
  }
}
.wrapper .main {
  border-radius: 45px 45px 0 0;
  height: 80svh;
  background-color: var(--ion-color-primary-darkgreen);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 20px 40px;
}
@media screen and (max-width: 420px) and (orientation: portrait) {
  .wrapper .main {
    padding: 20px;
  }
}
@media screen and (max-width: 320px) and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main {
    padding: 10px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main {
    height: 75svh;
    padding: 10px 25px;
  }
}
.wrapper .main .mr-potty,
.wrapper .main .mr-potty-hands {
  position: absolute;
  top: -75px;
  left: 60%;
  transform: translateX(-60%);
  z-index: -1;
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main .mr-potty,
  .wrapper .main .mr-potty-hands {
    top: -60px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .mr-potty,
  .wrapper .main .mr-potty-hands {
    top: -55px;
  }
}
.wrapper .main .mr-potty img:first-child,
.wrapper .main .mr-potty-hands img:first-child {
  width: 120px;
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main .mr-potty img:first-child,
  .wrapper .main .mr-potty-hands img:first-child {
    width: 100px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .mr-potty img:first-child,
  .wrapper .main .mr-potty-hands img:first-child {
    width: 90px;
  }
}
.wrapper .main .mr-potty .bubble,
.wrapper .main .mr-potty-hands .bubble {
  position: absolute;
  top: -65px;
  left: -130px;
  width: 150px;
  transform: rotate(16deg);
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main .mr-potty .bubble,
  .wrapper .main .mr-potty-hands .bubble {
    top: -55px;
    left: -90px;
    width: 120px;
  }
}
@media screen and (max-height: 570px) and (orientation: portrait) {
  .wrapper .main .mr-potty .bubble,
  .wrapper .main .mr-potty-hands .bubble {
    top: -40px;
    left: -95px;
    width: 110px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .mr-potty .bubble,
  .wrapper .main .mr-potty-hands .bubble {
    top: -30px;
    left: -105px;
    width: 100px;
  }
}
@media screen and (max-height: 350px) and (orientation: landscape) {
  .wrapper .main .mr-potty .bubble,
  .wrapper .main .mr-potty-hands .bubble {
    top: -12px;
    left: -90px;
    width: 85px;
    transform: none;
  }
}
.wrapper .main .mr-potty .bubble img,
.wrapper .main .mr-potty-hands .bubble img {
  width: 100%;
}
.wrapper .main .mr-potty .bubble p,
.wrapper .main .mr-potty-hands .bubble p {
  margin: 0;
  width: 77px;
  position: absolute;
  top: 31px;
  left: 21px;
  transform: rotate(-16deg);
  color: #624120;
  text-align: center;
  font-size: 14px;
  font-style: italic;
  font-weight: 700;
  line-height: 16px;
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main .mr-potty .bubble p,
  .wrapper .main .mr-potty-hands .bubble p {
    top: 25px;
    left: 12px;
  }
}
@media screen and (max-height: 570px) and (orientation: portrait) {
  .wrapper .main .mr-potty .bubble p,
  .wrapper .main .mr-potty-hands .bubble p {
    top: 18px;
    left: 8px;
    font-size: 12px;
    width: 75px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .mr-potty .bubble p,
  .wrapper .main .mr-potty-hands .bubble p {
    width: 63px;
    top: 20px;
    left: 10px;
    font-size: 12px;
    line-height: 12px;
  }
}
@media screen and (max-height: 350px) and (orientation: landscape) {
  .wrapper .main .mr-potty .bubble p,
  .wrapper .main .mr-potty-hands .bubble p {
    width: 63px;
    top: 14px;
    left: 5px;
    font-size: 11px;
    line-height: 12px;
    transform: none;
  }
}
.wrapper .main .mr-potty-hands {
  z-index: 1;
}
.wrapper .main .mr-potty-hands .mr-potty-invisible {
  opacity: 0;
}
.wrapper .main .mr-potty-hands .left-arm {
  width: 22px;
  position: absolute;
  top: 64px;
  left: 29px;
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main .mr-potty-hands .left-arm {
    width: 18px;
    top: 54px;
    left: 25px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .mr-potty-hands .left-arm {
    width: 16px;
    top: 49px;
    left: 23px;
  }
}
.wrapper .main .mr-potty-hands .right-arm {
  width: 22px;
  position: absolute;
  top: 64px;
  right: 5px;
}
@media screen and (max-height: 740px) and (orientation: portrait) {
  .wrapper .main .mr-potty-hands .right-arm {
    width: 18px;
    top: 53px;
    right: 3px;
  }
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .mr-potty-hands .right-arm {
    width: 16px;
    top: 48px;
    right: 3px;
  }
}
.wrapper .main .main-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.wrapper .main .main-content .title {
  color: var(--ion-color-primary-contrast);
  text-align: center;
  font-size: 24px;
  font-weight: 700;
  line-height: 35px;
  margin-bottom: 0;
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .main-content .title {
    font-size: 20px;
    margin-top: 0;
  }
}
.wrapper .main .main-content app-progress-bar {
  margin: 3svh 0;
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .main-content app-progress-bar {
    margin: 1.5svh 0 2svh;
  }
}
.wrapper .main .main-content .thoughts {
  display: flex;
  flex-direction: column;
  width: 100%;
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .main-content .thoughts {
    width: 80%;
  }
}
.wrapper .main .main-content .thoughts .thoughts-field {
  height: 25svh;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.25);
  border: none;
  outline: none;
  resize: none;
  padding: 12px 15px 0;
  margin-bottom: 6px;
  color: var(--ion-color-primary-contrast);
  font-weight: 400;
  line-height: 25px;
}
@media screen and (max-height: 425px) and (orientation: landscape) {
  .wrapper .main .main-content .thoughts .thoughts-field {
    margin-bottom: 0;
  }
}
@media screen and (max-height: 320px) and (orientation: landscape) {
  .wrapper .main .main-content .thoughts .thoughts-field {
    height: 20svh;
    margin-bottom: 0;
  }
}
.wrapper .main .main-content .thoughts .thoughts-field:focus {
  border: 1px solid var(--ion-color-primary-contrast);
}
.wrapper .main .main-content .thoughts .thoughts-field:focus::placeholder {
  color: transparent;
}
.wrapper .main .main-content .thoughts .thoughts-field::placeholder {
  color: var(--ion-color-primary-contrast);
  opacity: 0.25;
}
.wrapper .main .main-content .thoughts .thoughts-field::-webkit-scrollbar {
  scroll-margin: 10px;
  width: 20px;
  scroll-behavior: smooth;
}
.wrapper .main .main-content .thoughts .thoughts-field::-webkit-scrollbar-thumb {
  background-color: var(--ion-color-primary-contrast);
  border-radius: 40px;
  background-clip: content-box;
  border: 5px solid transparent;
}
.wrapper .main .main-content .thoughts .length-counter {
  align-self: flex-end;
  color: var(--ion-color-primary-contrast);
  font-size: 12px;
  font-weight: 600;
  line-height: 30px;
  margin-right: 10px;
}
/*# sourceMappingURL=add-thoughts.css.map */
